/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentProxy } from '../../models/DocumentProxy';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `DocumentProxy` model.
 */
@Injectable()
export class DocumentProxyApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, errorHandler);
  }

  /**
   * Proxies a DE-RENA invoice document request to the document-api service.
   *
   * @param {string} customerId 
   *
   * @param {string} templateName 
   *
   * @param {object} data Request data.
   *
   *  - `customerData` – `{any}` - 
   *
   *  - `res` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public invoice(customerId: any, templateName: any = {}, customerData: any = {}, res: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/document-proxy/invoice/:customerId";
    let _routeParams: any = {
      customerId: customerId
    };
    let _postBody: any = {
      customerData: customerData
    };
    let _urlParams: any = {};
    if (typeof templateName !== 'undefined' && templateName !== null) _urlParams.templateName = templateName;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Proxies a MO-RENA invoice document request to the document-api service.
   *
   * @param {string} customerId 
   *
   * @param {object} data Request data.
   *
   *  - `body` – `{object}` - 
   *
   *  - `res` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public moRenaInvoice(customerId: any, body: any = {}, res: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/document-proxy/mo-rena-invoice/:customerId";
    let _routeParams: any = {
      customerId: customerId
    };
    let _postBody: any = {
      body: body
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `DocumentProxy`.
   */
  public getModelName() {
    return "DocumentProxy";
  }
}
